// extracted by mini-css-extract-plugin
export default {"label":"BooleanFilter_label__c64cj","labelSelected":"BooleanFilter_labelSelected__C5iKk","labelEllipsis":"BooleanFilter_labelEllipsis__TcS15"};